import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ManageFloorPlan.Title',
    defaultMessage: 'Fortress - Manage Floor Plan',
  },
  header: {
    id: 'App.ManageFloorPlan.Header',
    defaultMessage: 'Manage Floor Plan',
  },
  floorPlanName: {
    id: 'App.ManageFloorPlan.FloorPlansTable.FloorPlanName',
    defaultMessage: 'Name',
  },
  floorPlanPrograms: {
    id: 'App.ManageFloorPlan.FloorPlansTable.FloorPlanPrograms',
    defaultMessage: 'Programs',
  },
  floorPlanMarketingName: {
    id: 'App.ManageFloorPlan.FloorPlansTable.FloorPlanMarketingName',
    defaultMessage: 'Marketing Name',
  },
  beds: {
    id: 'App.ManageFloorPlan.FloorPlansTable.Beds',
    defaultMessage: 'Beds/Baths',
  },
  squareFeet: {
    id: 'App.ManageFloorPlan.FloorPlansTable.SquareFeet',
    defaultMessage: 'Sq.Ft.',
  },
  numberOfUnits: {
    id: 'App.ManageFloorPlan.FloorPlansTable.NumberOfUnits',
    defaultMessage: '# Units',
  },
  marketRent: {
    id: 'App.ManageFloorPlan.FloorPlansTable.BaseMarketRent',
    defaultMessage: 'Base Market Rent',
  },
  basicRent: {
    id: 'App.ManageFloorPlan.FloorPlansTable.basicRent',
    defaultMessage: 'Basic Rent',
  },
  noteRent: {
    id: 'App.ManageFloorPlan.FloorPlansTable.noteRent',
    defaultMessage: 'Note Rent',
  },
  grossRentLimit: {
    id: 'App.ManageFloorPlan.FloorPlansTable.GrossRentLimit',
    defaultMessage: 'Gross Rent Limit',
  },
  financialMarketRent: {
    id: 'App.ManageFloorPlan.FloorPlansTable.FinancialMarketRent',
    defaultMessage: 'Financial Market Rent',
  },
  marketRentGrossUa: {
    id: 'App.ManageFloorPlan.FloorPlansTable.BaseMarketRentGrossUa',
    defaultMessage: '(Gross Rent - Largest UA - Non-Optional Charge)',
  },
  HUDGrossRentLimit: {
    id: 'App.ManageFloorPlan.FloorPlansTable.HUDGrossRentLimit',
    defaultMessage: 'HUD Gross Rent Limit',
  },
  quotingRent: {
    id: 'App.ManageFloorPlan.FloorPlansTable.QuotingRent',
    defaultMessage: 'Quoting Rent',
  },
  suggestedDeposit: {
    id: 'App.ManageFloorPlan.FloorPlansTable.SuggestedDeposit',
    defaultMessage: 'Suggested Deposit',
  },
  view: {
    id: 'App.ManageFloorPlan.FloorPlansTable.View',
    defaultMessage: 'View',
  },
  changeHudLimits: {
    id: 'App.ManageFloorPlan.FloorPlansTable.ChangeHudLimits',
    defaultMessage: 'Change HUD Limits',
  },
  changeRDLimits: {
    id: 'App.ManageFloorPlan.FloorPlansTable.ChangeRDLimits',
    defaultMessage: 'Change RD Limits',
  },
});

export default messages;
